export default __webpack_public_path__ + "static/quality-protect-guarantee-7c5b71cc8d60c143bf830cf9f13e8c91.png";